import { createContext, useContext, useState, useCallback } from 'react';
import translations from '@/i18n/translations';

const LanguageContext = createContext(null);

const SUPPORTED_LANGS = ['fr', 'nl'];
const DEFAULT_LANG = 'fr';

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('destockpro_lang');
    return SUPPORTED_LANGS.includes(saved) ? saved : DEFAULT_LANG;
  });

  const switchLang = useCallback((newLang) => {
    if (SUPPORTED_LANGS.includes(newLang)) {
      setLang(newLang);
      localStorage.setItem('destockpro_lang', newLang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLang must be used within LanguageProvider');
  return context;
}

export function useTranslation(section) {
  const { lang } = useLang();

  const t = (key) => {
    const sectionData = translations[section];
    if (!sectionData) return key;
    const langData = sectionData[lang] || sectionData['fr'];
    if (!langData) return key;
    return langData[key] ?? key;
  };

  const tc = (key) => {
    const langData = translations.common?.[lang] || translations.common?.['fr'];
    return langData?.[key] ?? key;
  };

  return { t, tc, lang };
}
